import { Pipe, PipeTransform } from "@angular/core";
import { KeyString } from '../constants/types';

@Pipe({
	name: 'enumValue',
})
export class EnumValuePipe implements PipeTransform {
	transform(value: string | null | undefined, enumVar: KeyString): string {
		if (value) {
			return enumVar[value];
		}
		return '';
	}
}